import Requester from './Requester';
export var createRequester = function (_a) {
    var baseUrl = _a.baseUrl, _b = _a.httpFilters, httpFilters = _b === void 0 ? [] : _b;
    return new Requester(baseUrl, httpFilters);
};
